import ActiveFilters from './ActiveFilters.vue'

export default ActiveFilters
